/**
 * SeeMe Inline Edit
 * Click-to-edit text: a span that swaps to a real input while editing,
 * then back to plain text on commit/cancel. Use sparingly — for names and
 * titles where a permanently-rendered input (.form-control--transparent)
 * is too heavy and the value should read as true text at rest.
 *
 * Usage (HTML):
 *   <span class="inline-edit" data-inline-edit>Current value</span>
 *
 * Behavior:
 *   Click       — swaps to <input class="form-control form-control-sm">
 *   Enter/blur  — commits (trimmed; empty input cancels), restores the span
 *   Escape      — cancels, restores the original text
 *
 * Custom events (dispatched from the span, bubble):
 *   'inline-edit:commit' — detail: { value, oldValue } (only fired on change)
 *   'inline-edit:cancel' — detail: { value }
 *
 * JS API:
 *   SeeMe.inlineEdit.start(el) — programmatically enter edit mode
 */

var SeeMe = window.SeeMe || {};

SeeMe.inlineEdit = (function () {
    'use strict';

    var HOOK = '[data-inline-edit]';
    var activeInput = null;    // the input currently editing, if any
    var swallowClick = false;  // eat the click that dismisses an active edit

    function start(span) {
        if (!span || span._inlineEditing) return;
        span._inlineEditing = true;

        var oldValue = span.textContent.trim();
        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'form-control form-control-sm inline-edit__input';
        input.value = oldValue;

        var finished = false;

        function restore(value) {
            if (finished) return;
            finished = true;
            span.textContent = value;
            input.replaceWith(span);
            span._inlineEditing = false;
            if (activeInput === input) activeInput = null;
        }

        function commit() {
            // replaceWith() on a focused input fires a synchronous blur —
            // without this guard every commit/cancel re-enters here and
            // dispatches duplicate events
            if (finished) return;
            var v = input.value.trim();
            if (v && v !== oldValue) {
                restore(v);
                span.dispatchEvent(new CustomEvent('inline-edit:commit', {
                    bubbles: true,
                    detail: { value: v, oldValue: oldValue }
                }));
            } else {
                cancel();
            }
        }

        function cancel() {
            if (finished) return;
            restore(oldValue);
            span.dispatchEvent(new CustomEvent('inline-edit:cancel', {
                bubbles: true,
                detail: { value: oldValue }
            }));
        }

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); commit(); }
            else if (e.key === 'Escape') { cancel(); }
        });
        input.addEventListener('blur', commit);

        span.replaceWith(input);
        input.focus();
        input.select();
        activeInput = input;
    }

    // A mousedown outside an active edit dismisses it (blur commits).
    // Flag it so the CLICK that follows can't also start a new edit —
    // same convention as dropdowns/modals swallowing their dismissing click.
    // Recomputed every mousedown, so a stale flag can't eat a later click.
    document.addEventListener('mousedown', function (e) {
        swallowClick = !!(activeInput && e.target !== activeInput);
    }, true);

    document.addEventListener('click', function (e) {
        if (swallowClick) { swallowClick = false; return; }
        var span = e.target.closest(HOOK);
        if (span) start(span);
    });

    return { start: start };
})();

window.SeeMe = SeeMe;
